import { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getHeros } from "../../api/Heros";
import StarLoader from "../loader/StarLoader";

const settings = {
  dots: false,
  arrows: true,
  speed: 1200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  fade: true,
};

const Hero2 = ({ heros }) => {
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  return (
    <section className="wpo-hero-slider">
      <div className="hero-container">
        <div className="hero-wrapper">
          <Slider {...settings}>
            {heros.map((hero) => (
              <div key={hero.id} className="hero-slide">
                <div
                  className="slide-inner slide-bg-image"
                  style={{
                    backgroundImage: `url("${apiUrl}/storage/${hero.file}")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    objectFit: "contain",
                  }}
                >
                  <div className="container-fluid">
                    <div
                      className="slide-content"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "0px",
                      }}
                    >
                      <div className="slide-title-sub">
                        <h5
                          style={{
                            fontSize: "2.5rem",
                            fontWeight: "700",
                            lineHeight: "1.2",
                          }}
                        >
                          {hero.title}
                        </h5>
                      </div>
                      <div className="slide-text">
                        <p
                          style={{
                            textAlign: "justify",
                          }}
                          dangerouslySetInnerHTML={{ __html: hero.description }}
                        />
                      </div>
                      <div className="btns">
                        <Link to="/about" className="theme-btn">
                          Explore More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Hero2;
